// extracted by mini-css-extract-plugin
export default {"nestedData":"NestedData_nestedData__Zp5LL","key":"NestedData_key__o7iuG","value":"NestedData_value__6t+lb","arrayItem":"NestedData_arrayItem__qBbTq"};